import React from "react";
import { NavLink } from "react-router";
import Wrapper from "../hooks/wrapper";

import {
  SiAdobephotoshop,
  SiAdobeillustrator,
  SiAdobepremierepro,
  SiAdobeaftereffects,
  SiAutodesk,
  SiUnrealengine,
} from "react-icons/si";
import { BiLogoVisualStudio } from "react-icons/bi";

function Skills(props) {
  return (
    <li className="SkillsDetail">
      {props.icon}
      <span>{props.text}</span>
    </li>
  );
}

function About() {
  return (
    <Wrapper>
      <div className="Pages">
        <div className="PageTitle">
          <span>ABOUT</span>
          <NavLink to="/">← Previous</NavLink>
        </div>
        <div className="PageContent" style={{ gap: "200px" }}>
          <div className="AboutLogo">
            <span className="PageSubtitle">브랜드, GYEONG.</span>
            <img
              src={`${process.env.PUBLIC_URL}/images/gyeong_logo.svg`}
              alt="2022 GYEONG LOGO"
            />
            <div>
              <p>
                'GYEONG' 이라는 브랜딩과 닉네임은 저의 이름 중 공경함을 뜻하는
                敬(경) 에서 따와 지었습니다.
              </p>
              <p>
                로고는 '모두를 위한 엔터테인먼트' 라는 목적을 가지고 친근하게
                접근 가능한 로고를 원했습니다.
              </p>
              <p>
                그리하여 최신 트렌드인 모던함과 귀여운 둥글둥글한 도형을 섞은
                현재의 로고를 직접 디자인 하였습니다.
              </p>
              <p>마치 장난감과 같은 느낌을 받을 수 있습니다.</p>
            </div>
          </div>
          <div className="AboutCareer">
            <span className="PageSubtitle">정보</span>
            <ul>
              <li>
                <p>이름</p>
                <p className="CareerSub">이경민 · Lee GyeongMin</p>
              </li>
              <li>
                <p>생년월일</p>
                <p className="CareerSub">2003.10.21</p>
              </li>
              <li>
                <p>학력</p>
                <p className="CareerSub">
                  2021년 서울영상고등학교 졸업 · 영상미디어 전공
                </p>
              </li>
              <li>
                <p>군필여부</p>
                <p className="CareerSub">
                  2023.06.23 ~ 2024.12.26 · 병역필 · 대한민국 육군
                </p>
              </li>
            </ul>
          </div>
          <div className="AboutCareer">
            <span className="PageSubtitle">커리어</span>
            <ul>
              <li>
                <p>갤러리미호 · 계약직</p>
                <p className="CareerSub">2025년 8월 ~ 2026년 5월 · 9개월</p>
                <p className="CareerSub">대한민국 인천 · 대면근무</p>
                <p>디자인팀</p>
              </li>
              <li>
                <p>IMJ Foundation · 정규직</p>
                <p className="CareerSub">
                  2021년 10월 ~ 2022년 11월 · 1년 2개월
                </p>
                <p className="CareerSub">대한민국 서울 · 대면근무</p>
                <p>영상디자인팀</p>
              </li>
            </ul>
          </div>
          <div className="AboutCareer">
            <span className="PageSubtitle">자격증</span>
            <ul>
              <li>
                <p>컴퓨터그래픽기능사</p>
                <p className="CareerSub">2021.07.16 취득 · 한국산업인력공단</p>
              </li>
              <li>
                <p>GTQ(그래픽기술자격) 1급</p>
                <p className="CareerSub">2014.11.14 취득 · 한국생산성본부</p>
              </li>
              <li>
                <p>ITQ(정보기술자격) A등급</p>
                <p className="CareerSub">
                  아래한글 - 2014.11.14 취득 · 한국생산성본부
                </p>
                <p className="CareerSub">
                  한글엑셀 - 2016.03.17 취득 · 한국생산성본부
                </p>
                <p className="CareerSub">
                  한글파워포인트 - 2019.05.30 취득 · 한국생산성본부
                </p>
              </li>
            </ul>
          </div>
          <div className="AboutCareer">
            <span className="PageSubtitle">수상</span>
            <ul>
              <li>
                <p>제27회 커뮤니케이션디자인 국제공모전 입선</p>
                <p className="CareerSub">2021년 · 한국커뮤니케이션디자인협회</p>
              </li>
              <li>
                <p>제3회 불독국제영화제 청소년부 장려상</p>
                <p className="CareerSub">
                  2020년 · 재단법인 피앤에프 / 불독국제영화제
                </p>
              </li>
            </ul>
          </div>
          <div className="AboutSkills">
            <span className="PageSubtitle">기술</span>
            <br />
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <Skills icon={<SiAdobephotoshop />} text="Adobe Photoshop" />
              <Skills icon={<SiAdobeillustrator />} text="Adobe Illustrator" />
              <Skills
                icon={<SiAdobeaftereffects />}
                text="Adobe After Effects"
              />
              <Skills icon={<SiAdobepremierepro />} text="Adobe Premiere Pro" />
              <Skills icon={<SiAutodesk />} text="Autodesk 3ds Max" />
              <Skills
                icon={<BiLogoVisualStudio />}
                text="HTML, CSS, JavaScript, ReactJS"
              />
              <Skills icon={<SiUnrealengine />} text="Unreal Engine" />
            </ul>
          </div>
          <div className="AboutProject">
            <span className="PageSubtitle">프로젝트</span>
            <ul
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                fontSize: "20px",
              }}
            >
              <li>
                <span style={{ fontWeight: 700, textDecoration: "underline" }}>
                  <a
                    href="https://www.instagram.com/life_saves._/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    라이프 세이브스 · Life Saves →
                  </a>
                </span>
                <p>
                  라이프 세이브스는 바쁜 현대인의 삶 속에서, 코로나로 인해
                  혼란한 삶 속에서
                </p>
                <p>
                  잊혀져 가는 목소리를 대변하기 위해 결성된 “후원 목적 프로젝트
                  팀”입니다.
                </p>
                <p>
                  그들의 이야기를 담은 카드뉴스와 제품을 제작하여 세상에 알리고,
                </p>
                <p>
                  모은 금액을 기부하여 많은 사람들이 간접적으로나마 도움의
                  손길을 내밀 수 있도록 기획하였습니다.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default About;
